/*
  Tiroir de panier façon Rue des Peignoirs (02-11) — carte « Va bien avec » / « Votre 2e … à −X % ».
  Écoute globale, posée une seule fois : le tiroir est redessiné à chaque changement de panier
  (cart-drawer.js remplace .cart-drawer__inner), un script placé dedans ne se relancerait pas.
  🔴 Article à plusieurs variantes : AUCUNE n'est pré-choisie. Le « + » sans choix n'ajoute rien,
     il montre le menu et le message « Choisissez d'abord … ».
*/
import { CartUpdatedEvent } from '@theme/events';

if (!window.__rdpPanier) {
  window.__rdpPanier = true;

  const el = (tag, cls, txt) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  };

  // Prix de la carte : il suit la variante choisie (prix remisé seulement si l'option le porte).
  document.addEventListener('change', (e) => {
    const sel = e.target.closest && e.target.closest('[data-rdp-duo-var]');
    if (!sel || sel.tagName !== 'SELECT') return;
    const bloc = sel.closest('[data-rdp-duo]');
    if (!bloc) return;
    const msg = bloc.querySelector('[data-rdp-duo-msg]');
    sel.classList.remove('is-erreur');
    if (msg) msg.hidden = true;
    const o = sel.selectedOptions[0];
    const prix = bloc.querySelector('[data-rdp-duo-prix]');
    if (!o || !o.value || !prix) return;
    prix.textContent = '';
    if (o.dataset.r) {
      prix.append(el('b', null, o.dataset.r), ' ', el('s', null, o.dataset.p), ' ', el('span', 'rdp-cd-duo__badge', bloc.dataset.badge || ''));
    } else {
      prix.append(el('b', null, o.dataset.p));
    }
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('[data-rdp-duo-ajout]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    const bloc = btn.closest('[data-rdp-duo]');
    const champ = bloc && bloc.querySelector('[data-rdp-duo-var]');
    if (!champ) return;
    if (!champ.value) {
      const msg = bloc.querySelector('[data-rdp-duo-msg]');
      if (msg) msg.hidden = false;
      champ.classList.add('is-erreur');
      champ.focus();
      return;
    }
    btn.disabled = true;
    btn.classList.add('is-chargement');
    const tiroir = document.querySelector('cart-drawer');
    const idSection = tiroir && tiroir.dataset.sectionId ? tiroir.dataset.sectionId : '';
    const url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(champ.value), quantity: 1 }], sections: idSection, sections_url: window.location.pathname }),
    })
      .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (!ok || (j.status && j.status >= 400)) throw new Error(j.description || j.message || 'Ajout impossible');
        // Le nombre d'articles est relu dans le tiroir que Shopify vient de rendre : pas de requête de plus.
        let n;
        const html = j.sections && j.sections[idSection];
        if (html) {
          const t = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rdp-count]');
          if (t) n = Number(t.dataset.rdpCount);
        }
        if (n == null || Number.isNaN(n)) {
          const ic = document.querySelector('cart-icon');
          const c = ic && ic.getCurrentItemCount ? ic.getCurrentItemCount() : null;
          n = c != null ? Number(c) + 1 : 1;
        }
        document.dispatchEvent(new CartUpdatedEvent({}, { itemCount: n, source: 'rdp-panier', sections: j.sections }));
      })
      .catch((err) => {
        document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: String((err && err.message) || err) } }));
        btn.disabled = false;
        btn.classList.remove('is-chargement');
      });
  });
}
